// /components/simulator/ModelYearlyChart.jsx

import React from 'react';
import TraditionalRentalYearlyChart from './charts/TraditionalRentalYearlyChart';
import BankLendingYearlyChart from './charts/BankLendingYearlyChart';
import RentToOwnYearlyChart from './charts/RentToOwnYearlyChart';
import RentToOwnGoldYearlyChart from './charts/RentToOwnGoldYearlyChart';
import RentToOwnRealEstateYearlyChart from './charts/RentToOwnRealEstateYearlyChart';
import RentToOwnBusinessYearlyChart from './charts/RentToOwnBusinessYearlyChart';
import RentToOwnStockYearlyChart from './charts/RentToOwnStockYearlyChart';
import GoldInvestmentYearlyChart from './charts/GoldInvestmentYearlyChart';
import StockInvestmentYearlyChart from './charts/StockInvestmentYearlyChart';
import BusinessInvestmentYearlyChart from './charts/BusinessInvestmentYearlyChart';

const ModelYearlyChart = ({ modelName, yearlyData, investorResult }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No chart data available.</div>;
  }

  


  switch (modelName) {
    case 'Traditional Rental':
      return <TraditionalRentalYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Bank Lending':
      return <BankLendingYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Rent-to-Own':
      return <RentToOwnYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Rent-to-Own + Gold':
      return <RentToOwnGoldYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Rent-to-Own + Real Estate':
      return <RentToOwnRealEstateYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    // case 'Rent-to-Own + Business':
    //   return <RentToOwnBusinessYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Rent-to-Own + Stock':
      return <RentToOwnStockYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Gold Investment':
      return <GoldInvestmentYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    case 'Stock Investment':
      return <StockInvestmentYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    // case 'Business Investment':
    //   return <BusinessInvestmentYearlyChart yearlyData={yearlyData} investorResult={investorResult} />;
    default:
      return <div className="text-center text-gray-500">Chart not available for this model.</div>;
  }
};

export default ModelYearlyChart;
